<template>
    <v-dialog v-model="show" persistent width="">
        <v-card>
            <v-card-text class="text-xs-center">
                <v-progress-circular indeterminate :size="70" :width="7" :color="progressColor"></v-progress-circular>
                <h1 v-if="message != null">{{ message }}</h1>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
export default {
    name: "Loading",
    data: function( ) {
        return {
        }
    },
    computed: {
        show( ) {
            return this.$store.state.loading.show;
        },
        message( ) {
            return this.$store.state.loading.message;
        },
        progressColor( ) {
            return this.$store.state.loading.progressColor;
        }
    }
}
</script>

<style scoped>

</style>
